module.exports = __webpack_public_path__ + "static/media/Roboto-Light.10ad0f86.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Light.woff
// module id = 529
// module chunks = 0